import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "rescigo_partner_token";

export const partnerApi = axios.create({ baseURL: API });
partnerApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setPartnerToken = (t) => localStorage.setItem(KEY, t);
export const getPartnerToken = () => localStorage.getItem(KEY);
export const clearPartnerToken = () => localStorage.removeItem(KEY);
export const isPartnerAuthed = () => !!localStorage.getItem(KEY);

export function fmtPartnerErr(e) {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join("; ");
  return d || e?.message || "Request failed";
}
